var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"n-input-mini-input"},[_c('input',_vm._g(_vm._b({ref:"input",style:({'min-width': _vm.width}),attrs:{"type":_vm.s_type,"maxlength":_vm.s_maxlength,"step":_vm.step,"autocomplete":"off"}},'input',_vm.$attrs,false),_vm.$listeners)),_c('div',{ref:"hidden",staticClass:"n-hidden"},[_vm._v(_vm._s(_vm.hiddenValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }